





import {Component, Vue} from 'vue-property-decorator'

@Component
export default class NotFound extends Vue {
  mounted(): void {
    // Rails側の404へ飛ばす
    window.location.href = '/not_found'
  }
}
